import remap from './remap'
import create from 'zustand'
import store from '../store'
import { API } from './types'
import { State } from '../store/types'
import useAxiosRequest from './useAxiosRequest'
import { useCallback, useMemo, useState } from 'react'
import { useQuery as useReactQuery, UseQueryResult } from 'react-query'

const useQuery = <Filters>(
  defaultFilters?: Filters,
  options?: API.QueryOptions,
  axiosConfig?: API.Config
) => {
  const axios = useAxiosRequest(axiosConfig)

  const useStore = create<State>(store)

  const { networkId, target } = useStore(
    useCallback((state) => {
      return {
        networkId: state.networkId,
        target: state.target
      }
    }, [])
  )

  const [filters, setFilters] = useState<Filters>(defaultFilters)

  const enabled = useMemo(() => {
    return [!!networkId, !!target, ...(options?.enabled || [])].every(
      (x) => !!x
    )
  }, [networkId, target, options?.enabled])

  const query = <Data>(request: API.QueryParams) => {
    const cacheKey = [...request?.cacheKey, filters]

    const requestParams = {
      ...request,
      params: {
        ...(request?.params || {}),
        ...(filters || {})
      }
    }

    const response = useReactQuery(cacheKey, () => axios(requestParams), {
      ...(options || {}),
      enabled
    })

    return remap<Data, Filters, UseQueryResult<Data>>({
      response,
      filters,
      setFilters
    })
  }

  return query
}

export default useQuery
